import { z } from 'zod';
import { EmailSchema, OrgIdSchema, PersonIdSchema, PhoneSchema } from './common.js';

/**
 * Representerer en fysisk person på tvers av flere identiteter og kilder.
 * Samme person kan dukke opp med ulike e-poster, navn og telefonnumre.
 */
export const PersonSchema = z.object({
  id: PersonIdSchema,
  navn: z.string().min(1, 'Personnavn kan ikke være tomt'),
  emails: z.array(EmailSchema),
  phones: z.array(PhoneSchema),
  organisasjonId: OrgIdSchema.optional(),
  /** Alternative navn, brukernavn, visningsnavn m.m. */
  aliases: z.array(z.string()),
  /** Normalisert navn for sammenligning og deduplisering */
  normalizedName: z.string().min(1, 'NormalizedName kan ikke være tomt'),
});

export type Person = z.infer<typeof PersonSchema>;
